<ion-segment
  class="tabs-getm"
  [value]="selected"
  (ionChange)="onSegmentChange($event)"
  mode="md"
>
  <ng-container *ngFor="let tab of tabs">
    <ion-segment-button mode="md" [value]="tab.id" class="tabs-getm__button">
      <ion-label mode="md" class="label-segment"> {{ tab.title }}</ion-label>
    </ion-segment-button>
  </ng-container>
</ion-segment>
